<template>
  <div class="pdf-lenovo-invoice-form">
    <transition name="fade">
      <div class="invoice-form-module">
        <div class="invoice-title">
          <div class="back-color" />
          <div class="top">
            <i class="sprite-icon sprite-icon-home-logo" />填写开票信息
          </div>
          
          <div
            @click="closeInvoiceForm"
            class="close-icon"
          >
          </div>
        </div>
        <div class="invoice-content">
          <!-- 待开票 -->
          <div
            v-if="invoiceStatus"
            class="invoice-waiting"
          >
            <p class="description">
              您正在申请发票，请填写以下信息
            </p>
            <div class="liner"></div>
            <div class="invoice-waiting_content">
              <ul>
                <li>
                  <div>订单编号:</div>
                  <div>{{ invoiceItem.order_id }}</div>
                </li>
                <li>
                  <div>开票金额:</div>
                  <div>{{ invoiceItem.order_fee }} 元</div>
                </li>
                <li>
                  <div>抬头类型:</div>
                  <div class="radio-box">
                    <div class="checkbox" @click="invoiceType = '1'">
                      <span class="box" :class="invoiceType === '1' ? 'checked' : 'unchecked'"></span>
                      <label>个人</label>
                    </div>
                    <div class="checkbox" @click="invoiceType = '2'">
                      <span class="box" :class="invoiceType === '2' ? 'checked' : 'unchecked'"></span>
                      <span>企业</span>
                    </div>
                  </div>
                </li>
                <li class="input-li">
                  <div>发票抬头:</div>
                  <div class="input-wrapper">
                    <input
                      :class="titleError ? 'input-warn' : ''"
                      v-model="invoiceTitle"
                      :placeholder="invoiceTitleHolder"
                      type="text"
                      @input="handleTitleInput"
                      @focus="handleTitleInput"
                      @blur="hideListWithDelay('title')"
                    >
                    <div v-if="invoiceTitle" class="clear-icon" @click="clearInput('title')">×</div>
                    <!-- 联想下拉列表 -->
                    <div v-if="showTitleSuggestions" class="suggestion-wrapper">
                      <ul class="suggestions">
                        <li 
                          v-for="(suggestion, index) in titleSuggestionsList" 
                          :key="index"
                          @mousedown="selectSuggestion(suggestion, 'title')"
                        >
                          <div v-html="highlightMatch(suggestion['name'], invoiceTitle)"></div>
                          <div class="tax-num">{{ suggestion['social_credit_code'] }}</div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
                <li
                  v-if="invoiceType === '2'"
                  class="input-li"
                >
                  <div>税号:</div>
                  <div class="input-wrapper">
                    <input
                      :class="taxError ? 'input-warn' : ''"
                      v-model="invoiceTaxNum"
                      type="text"
                      placeholder="填写需要开具发票的税号"
                      @input="formatTaxInput"
                      @focus="handleTaxInput"
                      @blur="hideListWithDelay('tax')"
                    >
                    <div v-if="invoiceTaxNum" class="clear-icon" @click="clearInput('tax')">×</div>
                    <!-- 联想下拉列表 -->
                    <div v-if="showTaxSuggestions" class="suggestion-wrapper">
                      <ul class="suggestions">
                        <li 
                          v-for="(suggestion, index) in taxSuggestionsList" 
                          :key="index"
                          @mousedown="selectSuggestion(suggestion, 'tax')"
                        >
                          <div>{{ suggestion['name'] }}</div>
                          <div class="tax-num" v-html="highlightMatch(suggestion['social_credit_code'], invoiceTaxNum)"></div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
            <div
              class="submit-btn"
            >
              <p @click="submitInvoiceData">提交</p>
            </div>
          </div>
          <!-- 开票成功 -->
          <div
            v-if="!invoiceStatus"
            class="invoice-success"
          >
            <img :src="require('@/assets/images/invoice-success.png')">
            <h2>已提交开票申请</h2>
            <p>预计3个工作日开具成功</p>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>
<script>
import { submitInvoiceInfo, searchEnterpriseInfo } from '@/api/user'
import electronTicket from '@/client/modules/electronTicket.js'

// 开票类型
const INVOICE_TYPE = {
  PERSONAL: '1', // 个人
  ENTERPRISE: '2', // 企业
}

const ERROR_TIPS = '开票信息有误，请检查并输入正确的抬头、税号'

// 防抖函数
function debounce(fn, delay) {
  let timer = null
  return function(...args) {
    if (timer) clearTimeout(timer)
    timer = setTimeout(() => {
      fn.apply(this, args)
    }, delay)
  }
}

export default {
  name: 'InvoiceForm',
  props: {
    invoiceItem: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },

  data () {
    return {
      invoiceType: INVOICE_TYPE.ENTERPRISE, // 开票类型
      invoiceTitle: '', // 发票抬头
      invoiceTaxNum: '', // 发票税号
      titleError: false, // 抬头warn
      taxError: false, // 税号warn
      invoiceStatus: this.invoiceItem.invoice_status === 1, // 填表 | 成功
      isRequestApi: false, // 是否正在请求api
      showTitleSuggestions: false, // 是否显示抬头联想列表
      showTaxSuggestions: false, // 是否显示税号联想列表
      titleSuggestionsList: [], // 抬头联想列表
      taxSuggestionsList: [], // 税号联想列表
    }
  },

  computed: {
    invoiceTitleHolder () {
      return this.invoiceType === INVOICE_TYPE.ENTERPRISE ? '填写需要开具发票的企业名称' : '填写需要开具发票的姓名'
    }
  },

  watch: {
    invoiceType: function (newVal, oldVal) {
      if (this.titleError) {
        this.titleError = false
      }
      if (this.taxError) {
        this.taxError = false
      }

      if (newVal === INVOICE_TYPE.PERSONAL) {
        this.invoiceTaxNum = ''
      }
    }
  },

  mounted () {
    if (this.invoiceStatus) {
      this.reportFunc({ page_show: 2 })
    }
  },

  methods: {
    // 关闭弹窗
    closeInvoiceForm () {
      this.$emit('closeInvoiceForm')
    },

    /**
     * 防抖处理的企业信息查询方法
     * @param {string} keyword - 输入关键词
     * @param {string} type - 查询类型，'title'表示发票抑头，'tax'表示税号
     * 该方法在300ms内多次调用时只执行最后一次，减少不必要的API请求
     */
    debouncedFetchCompanyInfo: debounce(function (keyword, type) {
      // 关键词为空或长度小于3时，不触发API请求，隐藏下拉列表
      if (!keyword || keyword.length < 3) {
        // 根据类型动态设置相应的状态变量
        this[type === 'title' ? 'showTitleSuggestions' : 'showTaxSuggestions'] = false
        this[type === 'title' ? 'titleSuggestionsList' : 'taxSuggestionsList'] = []
        return
      }

      // 调用API查询企业信息
      searchEnterpriseInfo({
        keyword,
        search_type: type === 'title' ? 1 : 2
      }).then(result => {
          if (result.resp_common && result.resp_common.ret !== 0) {
            return
          }

          const companies = result.companies || []
          // 有结果时显示下拉列表并更新数据
          if (companies.length > 0) {
            // 将查询结果设置到相应的列表变量
            this[type === 'title' ? 'titleSuggestionsList' : 'taxSuggestionsList'] = companies
            // 显示对应的下拉列表
            this[type === 'title' ? 'showTitleSuggestions' : 'showTaxSuggestions'] = true
          } else {
            // 无结果时隐藏下拉列表
            this[type === 'title' ? 'showTitleSuggestions' : 'showTaxSuggestions'] = false
          }
        }).catch(error => {
          // API请求失败时隐藏下拉列表并输出错误信息
          console.error('获取企业信息失败:', error)
          this[type === 'title' ? 'showTitleSuggestions' : 'showTaxSuggestions'] = false
        })
    }, 300), // 300ms的防抖延迟，平衡响应速度和请求频率

    // 监听抬头输入变化
    handleTitleInput() {
      this.titleError = false
      // 如果是个人开票类型，不调用企业信息查询API
      if (this.invoiceType === INVOICE_TYPE.PERSONAL) {
        // 确保隐藏了下拉列表
        this.showTitleSuggestions = false
        this.titleSuggestionsList = []
        return
      }
      this.debouncedFetchCompanyInfo(this.invoiceTitle, 'title')
    },

    /**
     * 格式化并处理税号输入
     * 规则：1. 只允许数字和大写字母 2. 自动将小写字母转为大写 3. 长度限制20位
     */
    formatTaxInput(event) {
      let value = this.invoiceTaxNum
      let hasError = false
      
      // 1. 检查非法字符并提示错误（使用防抖避免频繁提示）
      const hasInvalidChars = /[^0-9a-zA-Z]/.test(value)
      if (hasInvalidChars) {
        this.taxError = true
        hasError = true
        window.app.$toast(ERROR_TIPS, { duration: 2000 })
      }

      // 2. 清理并格式化内容：过滤非法字符并转大写
      value = value.replace(/[^0-9a-zA-Z]/g, '').toUpperCase()

      // 3. 处理长度限制
      if (value.length > 20) {
        this.taxError = true
        hasError = true
        value = value.slice(0, 20)  // 截取前20位
        window.app.$toast(ERROR_TIPS, { duration: 2000 })
      }

      // 4. 如果没有错误，清除错误状态
      if (!hasError) {
        this.taxError = false
      }
      this.invoiceTaxNum = value
      this.handleTaxInput()
    },

    // 监听税号输入变化
    handleTaxInput() {
      this.taxError = false
      this.debouncedFetchCompanyInfo(this.invoiceTaxNum, 'tax')
    },

    /**
     * 选择联想项
     * @param {Object} suggestion - 联想项数据对象
     * @param {string} type - 类型，'title'表示发票抬头，'tax'表示税号
     */
    selectSuggestion(suggestion, type) {
      // 无论是从抬头还是税号入口选择，都同时设置抬头和税号
      this.invoiceTitle = suggestion['name']
      this.invoiceTaxNum = suggestion['social_credit_code']

      // 隐藏相应的下拉列表
      this[type === 'title' ? 'showTitleSuggestions' : 'showTaxSuggestions'] = false
    },

    // 高亮显示匹配的关键词
    highlightMatch(text, keyword) {
      if (!keyword || keyword.length < 3) return text

      const index = text.indexOf(keyword)
      if (index === -1) return text

      return (
        text.substring(0, index) +
        `<span style="background-color:#fefc9f;">${text.substring(index, index + keyword.length)}</span>` +
        text.substring(index + keyword.length)
      )
    },

    // 清空输入框
    clearInput(type) {
      if (type === 'title') {
        this.invoiceTitle = ''
        this.showTitleSuggestions = false
        this.titleSuggestionsList = []
      } else {
        this.invoiceTaxNum = ''
        this.showTaxSuggestions = false
        this.taxSuggestionsList = []
      }
    },

    // 延迟隐藏下拉列表
    hideListWithDelay(type) {
      window.setTimeout(() => {
        if (type === 'title') {
          this.showTitleSuggestions = false
        } else {
          this.showTaxSuggestions = false
        }
      }, 200)
    },

    // 提交开票信息
    submitInvoiceData () {
      if (this.isRequestApi) return

      if (this.invoiceTitle.trim().length === 0) {
        this.titleError = true
        window.app.$toast(ERROR_TIPS, { duration: 2000 })
        return
      } else if (this.invoiceType === INVOICE_TYPE.ENTERPRISE) {
        if (this.titleError) {
          this.titleError = false
        }

        if (this.invoiceTaxNum.trim().length < 15) {
          this.taxError = true
          window.app.$toast(ERROR_TIPS, { duration: 2000 })
          return
        } else if (!(/^[a-zA-Z0-9]+$/.test(this.invoiceTaxNum))) {
          this.taxError = true
          window.app.$toast(ERROR_TIPS, { duration: 2000 })
          return
        }
      }

      if (this.titleError) {
        this.taxError = false
      }

      const invoiceObj = {
        order_id: this.invoiceItem.order_id,
        invoice_apply_type: Number(this.invoiceType),
        invoice_title: this.invoiceTitle.trim(),
        invoice_tax_no: this.invoiceTaxNum.trim()
      }

      this.isRequestApi = true
      submitInvoiceInfo(invoiceObj).then(res => {
        if (res.resp_common.ret === 0) {
          // 切换状态
          this.invoiceStatus = false
        } else {
          const errorMsg = '开具发票失败，请稍后再尝试'
          window.app.$toast(errorMsg)
        }
        this.isRequestApi = false
      })
    },

    // 上报
    reportFunc (params) {
      electronTicket.REPORT.reportElectronicInvoiceClickandShow(params)
    }
  }
}
</script>
<style scoped lang="scss">
.pdf-lenovo-invoice-form {
  background-color: rgba(0, 0, 0, 0.25);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  color: #333;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;

  .invoice-form-module {
    position: relative;
    width: 500px;
    min-height: 324px;
    border-radius: 4px;
    background: #fff;
    box-shadow: 0px 4px 20px 0px rgba(0, 0, 0, 0.25);

    .invoice-title {
      .back-color {
        width: 100%;
        height: 6px;
        background-color: #FDD63B;
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
      }
      .top {
        margin: 3px 0 0 5px;
        color: #B07400;
        font-size: 12px;
        line-height: 16px;

        i {
          margin-right: 5px;
        }
      }
      .close-icon {
        position: absolute;
        top: 6px;
        right: 0;
        width: 24px;
        height: 24px;
        background-image: url(~@/assets/images/not-close.png);
        cursor: pointer;

        &:hover {
          background-position-x: center;
        }
        &:active {
          background-position-x: right;
        }
      }
    }
    .invoice-content {
      padding: 20px 28px;
      height: calc(100% - 44px);
      box-sizing: border-box;

      .invoice-waiting {
        .description {
          color: #575757;
          font-size: 14px;
          line-height: 20px;
        }
        .liner {
          margin: 16px 0 2px 0;
          width: 100%;
          height: 1px;
          background-color: #EFEFEF;
        }
        .invoice-waiting_content {
          padding: 14px 0 24px 0;
          border-radius: 4px;
          font-size: 14px;
          color: #575757;
          background: #FFF;

          li {
            display: flex;
            align-items: center;
            margin-top: 12px;
            line-height: 24px;

            &:first-child {
              margin-top: unset;
            }
            div:first-child {
              margin-right: 8px;
              width: 75px;
            }
            div:last-child {
              font-size: 14px;
            }
            .input-wrapper {
              position: relative;
              width: 310px;

              input[type="text"] {
                padding-left: 8px;
                padding-right: 24px;
                width: 100%;
                height: 28px;
                line-height: 28px;
                border-radius: 2px;
                border: 1px solid #CCC;
                background: #FFF;
                box-sizing: border-box;
                font-size: 14px;

                &::selection {
                  background-color: rgba(0, 0, 0,.1);
                  color: #555;
                }
              }
              .clear-icon {
                position: absolute;
                right: 8px;
                top: 50%;
                transform: translateY(-50%);
                width: 16px;
                height: 16px;
                box-sizing: border-box;
                text-align: center;
                line-height: 14px;
                border-radius: 50%;
                color: #999;
                background-color: #ebebeb;
                font-size: 15px;
                cursor: pointer;

                &:hover {
                  color: #666;
                }
              }
              .suggestion-wrapper {
                position: absolute;
                top: 100%;
                left: 0;
                width: 100%;
                z-index: 10;
                margin-top: 2px;

                .suggestions {
                  max-height: 184px;
                  overflow-y: auto;
                  overflow-x: hidden;
                  border: 1px solid #ddd;
                  box-shadow: 0px 2px 4px 0px #00000026;
                  background-color: #fff;

                  li {
                    display: block;
                    margin-top: 0;
                    padding: 6px 16px;
                    font-size: 12px;
                    width: 92%;
                    cursor: pointer;

                    div {
                      width: 100%;
                      height: 16px;
                      line-height: 16px;
                      color: #444444;
                    }
                    &:hover {
                      background: #E9EAF2;
                    }
                    .tax-num {
                      color: #666666;
                      margin-top: 2px;
                      font-size: 12px;
                    }
                  }
                  &::-webkit-scrollbar {
                    width: 10px; /* 滚动条总宽度 */
                    background-color: transparent;
                  }
                  &::-webkit-scrollbar-track {
                    background-color: transparent; /* 轨道背景透明 */
                    margin: 2px 0; /* 轨道上下边距 */
                  }
                  &::-webkit-scrollbar-thumb {
                    /* 滑块宽度比滚动条窄 */
                    background: #c7c7c7;
                    border: 2px solid #fff; /* 通过边框创建左右边距 */
                    border-radius: 5px;
                  }
                }
              }
            }
            input[type="radio"]:last-child {
              margin-left: 20px;
            }
            .input-warn {
              border: 2px solid rgb(31, 98, 238) !important;
            }
            .radio-box {
              display: flex;

              .checkbox {
                display: flex;
                align-items: center;

                .box {
                  display: inline-block;
                  margin-right: 6px;
                  width: 14px;
                  height: 14px;
                  border-radius: 50%;
                  background-image: url(~@/assets/images/un-selected.png);

                  &.unchecked {
                    cursor: pointer;
                  }
                  &.checked {
                    background-image: url(~@/assets/images/selected.png);
                  }
                }
              }
            }
          }
          .input-li {
            margin-top: 11px;
          }
        }
        .submit-btn {
          display: flex;
          justify-content: center;

          p {
            display: flex;
            justify-content: center;
            align-items: center;
            padding: 8px 0px;
            width: 232px;
            height: 38px;
            border-radius: 19px;
            background: #DC320A;
            box-sizing: border-box;
            color: #FFF;
            font-size: 16px;
            letter-spacing: 2px;
            cursor: pointer;
          }
        }
      }
      .invoice-success {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        height: 254px;

        img {
          width: 44px;
        }
        h2 {
          padding: 12px 0 8px;
          font-size: 16px;
          font-weight: 400;
          color: #333;
          text-align: center;
        }
        p {
          color: #999;
          text-align: center;
          font-size: 14px;
        }
      }
    }
  }
}
</style>
